import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import WhatsAppButton from "../../components/feature/WhatsAppButton";
import HeroSection from "./components/HeroSection";
import ServicesPreviewSection from "./components/ServicesPreviewSection";
import BenefitsSection from "./components/BenefitsSection";
import ProcessSection from "./components/ProcessSection";
import StatsBar from "./components/StatsBar";
import CTASection from "./components/CTASection";

const Home = () => {
  return (
    <main style={{ fontFamily: "'Poppins', sans-serif" }}>
      <Navbar />
      <HeroSection />
      <StatsBar />
      <ServicesPreviewSection />
      <BenefitsSection />
      <ProcessSection />
      <CTASection />
      <Footer />
      <WhatsAppButton />
    </main>
  );
};

export default Home;
